/* eslint-disable no-useless-escape */
import * as isValidCpf from '@brazilian-utils/is-valid-cpf'
import { parseToString } from './parseNumbers'

const validateEmail = email => {
  if (!email) {
    return null
  }

  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email.trim().toLowerCase())
}

const validatePhone = phone => {
  const onlyNumbers = parseToString(phone)
  return (
    (onlyNumbers.length >= 10 && onlyNumbers.length <= 11) ||
    onlyNumbers.length === 0
  )
}

const validateEntry = (price, entry) => {
  if (!entry) return null
  const entryValue = Number(entry)
  const priceValue = Number(price)
  const minEntryValue = Number((priceValue * 0.1).toFixed(0))
  return entryValue >= minEntryValue && entryValue < priceValue
}

const validateMandatoryPhone = phone => {
  if (!phone) return null
  const onlyNumbers = phone.replace(/[^0-9]/g, '')

  return onlyNumbers.length >= 10 && onlyNumbers.length <= 11
}

const validateFullName = fullName =>
  /^([a-zA-Z\u00C0-\u017F]+\s)+[a-zA-Z\u00C0-\u017F]+$/.test(fullName.trim())

const validateCpf = cpf => isValidCpf.isValidCpf(cpf)

// Aceita CNPJ numerico e alfanumerico (DV calculado sobre charCode - 48)
const validateCnpj = cnpj => {
  if (!cnpj) return false

  const clean = String(cnpj)
    .replace(/[.\-/\s]/g, '')
    .toUpperCase()
    .trim()
  if (clean.length !== 14) return false
  if (/[^A-Z0-9]/.test(clean)) return false
  if (!/^\d{2}$/.test(clean.slice(12))) return false
  if (/^(.)\1+$/.test(clean)) return false

  const charToNum = c => c.charCodeAt(0) - 48
  const calcDigit = (base, weights) => {
    const sum = weights.reduce((acc, w, i) => acc + charToNum(base[i]) * w, 0)
    const rem = sum % 11
    return rem < 2 ? 0 : 11 - rem
  }
  const dv1 = calcDigit(clean, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  const dv2 = calcDigit(clean, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])

  return dv1 === parseInt(clean[12], 10) && dv2 === parseInt(clean[13], 10)
}

const validateBirthDate = dateString => {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false

  const [day, month, year] = dateString.split('/').map(n => parseInt(n, 10))

  if (year < 1000 || month === 0 || month > 12) return false
  if (year >= new Date().getFullYear()) return false

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29

  return day > 0 && day <= monthLength[month - 1]
}

const validateCurrency = value => Number(value) > 0

export {
  validateBirthDate,
  validateCnpj,
  validateCpf,
  validateCurrency,
  validateEmail,
  validateEntry,
  validateFullName,
  validatePhone,
  validateMandatoryPhone,
}
